import { Money } from '../../core/model/money';
import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class BankTransactionImport extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.amount = model.amount;
      this.bankAccountNumber = model.bankAccountNumber;
      this.currencyCode = model.currencyCode;
      this.debtorName = model.debtorName;
      this.transactionText = model.trasnactionText;
      this.transactionStatus = model.transactionStatus;
      this.importedAt = model.importedAt;
      this.transactionDate = model.transactionDate;
      this.isAutoGiro = model.isAutoGiro;
    }
  }

  amount: Money;
  bankAccountNumber: string;
  currencyCode: string;
  debtorName: string;
  transactionText: string;
  transactionStatus: number;
  importedAt: Date;
  isAutoGiro: boolean;
  transactionDate: LocalDate;
  get transactionStatusCaption(): string {
    return BankTransactionStatusToString(this.transactionStatus);
  }
  set transactionStatusCaption(value: number) {
    this.transactionStatus = value;
  }
  companyName: string;
}

export enum BankTransactionStatus {
  Handled = 0,
  Unhandled = 1,
  Ignored = 2,
}

export function BankTransactionStatusToString(status: BankTransactionStatus): string {
  switch (+status) {
    case BankTransactionStatus.Unhandled:
      return 'BANK_IMPORT_TRANSACTIONS.UNHANDLED';

    case BankTransactionStatus.Ignored:
      return 'BANK_IMPORT_TRANSACTIONS.IGNORED';

    case BankTransactionStatus.Handled:
      return 'BANK_IMPORT_TRANSACTIONS.HANDLED';

    default:
      throw new Error('Unsupported status.');
  }
}
